import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAppointments } from '@/hooks/data/useAppointments';
import { AppointmentsTable } from './appointments';
import { CreateAppointmentDialog } from '@/components/appointments/CreateAppointmentDialog';

export const Route = createFileRoute('/_app/appointments/viewing')({
  component: ViewingPage,
});

function ViewingPage() {
  const { t } = useTranslation();
  const [creating, setCreating] = useState(false);
  const { data: items = [], isLoading } = useAppointments({ type: 'besichtigung' });

  return (
    <section className="space-y-6">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight">
            {t('appointments.viewing.title', 'Besichtigungen')}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t('appointments.viewing.subtitle', 'Termine zur Besichtigung mit Käufern.')}
          </p>
        </div>
        <Button onClick={() => setCreating(true)} className="gap-2">
          <Plus className="h-4 w-4" />
          {t('appointments.create.cta', 'Neuer Termin')}
        </Button>
      </header>
      {isLoading ? (
        <p className="py-8 text-center text-sm text-ink-3">{t('common.loading', 'Lädt …')}</p>
      ) : (
        <AppointmentsTable items={items} />
      )}
      <CreateAppointmentDialog
        open={creating}
        onOpenChange={setCreating}
        defaultType="besichtigung"
      />
    </section>
  );
}
